import React, { useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import * as yup from 'yup';
import { toast } from 'react-toastify';

import { useSession } from '../../providers/SessionProvider';
import { getValidationSchema } from '../../utils/schemas';
import api from '../../services/api';

import ContentHeader from '../../components/ContentHeader';
import Footer from '../../components/Footer';
import MainHeader from '../../components/MainHeader';
import SideMenu from '../../components/SideMenu';
import MyLoadingOverlay from '../../components/MyLoadingOverlay';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';

function FAQForm() {
  const formRef = useRef(null);
  const {
    setIsAssessoryMenuSelected,
    _token,
    isLoading,
    setIsLoading,
  } = useSession();

  const handleSubmit = async data => {
    try {
      // Remove all previous errors
      formRef.current.setErrors({});

      const contactSchema = getValidationSchema('contact');
      const schema = yup.object().shape(contactSchema);

      await schema.validate(data, {
        abortEarly: false,
      });

      const config = {
        headers: { Authorization: `Bearer ${_token}` },
      };

      setIsLoading(true);

      await api.post('api/faqs/custom/send', data, config).then(response => {
        setIsLoading(false);

        toast.success('Mensagem enviada com sucesso!', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
    } catch (err) {
      const validationErrors = {};

      setIsLoading(false);

      if (err instanceof yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });

        formRef.current.setErrors(validationErrors);
      } else if (err.response) {
        const { message } = err.response.data;

        toast.error(`${message}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(`${err}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

  useEffect(() => {
    setIsAssessoryMenuSelected(true);
  }, []);

  return (
    <div className="interna gray">
      <div className="white" />
      <div className="container bug-height">
        <div className="row first-row">
          <div className="col grid_3 left-menu">
            <MainHeader />
            <SideMenu />
          </div>
          <div className="col grid_9 content">
            <ContentHeader />
            <h3>Assessoria Jurídica - Envie sua dúvida:</h3>
            <div className="enviar-duvida">
              <Form onSubmit={data => handleSubmit(data)} ref={formRef}>
                <p>
                  <Input type="text" name="subject" placeholder="Assunto" />
                </p>
                <p>
                  <Textarea name="content" placeholder="Descrição" />
                </p>
                <p>
                  <button type="submit">Enviar</button>
                </p>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {isLoading && <MyLoadingOverlay />}
    </div>
  );
}

export default FAQForm;
